import { render, staticRenderFns } from "./table-price-cell.vue?vue&type=template&id=a6c2b9a0&functional=true&"
import script from "./table-price-cell.vue?vue&type=script&lang=js&"
export * from "./table-price-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports